import React from 'react';
import { TeamMember, Team, Association } from '../../types/generated.types';

interface ShopTitleProps {
  teamMemberData?: {
    teamMember?: TeamMember;
  };
  teamData?: {
    team?: Team;
  };
  associationData?: {
    association?: Association;
  };
  salesStartDate?: string | null;
  salesEndDate?: string | null;
  bookletsLength: number;
}

const ShopTitle: React.FC<ShopTitleProps> = ({
  teamMemberData,
  teamData,
  associationData,
  salesStartDate,
  salesEndDate,
  bookletsLength
}) => {
  const now = new Date();
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);

  const startDate = salesStartDate ? new Date(salesStartDate) : null;
  const endDate = salesEndDate ? new Date(salesEndDate) : null;

  if (startDate) {
    startDate.setHours(0, 0, 0, 0);
  }
  if (endDate) {
    endDate.setHours(0, 0, 0, 0);
  }


  // If we're after the sales period, show the closed message
  if (endDate && today > endDate) {
    return <>
      <h2>
        {associationData && teamData && teamMemberData
          ? <>{teamMemberData?.teamMember?.firstname} {teamMemberData?.teamMember?.lastname}</>
          : teamData ? teamData?.team?.name
            : associationData?.association?.name
        }
      </h2>
      {teamData &&
        <h3>
          {teamMemberData
            ? <>{teamData?.team?.name}, {associationData?.association?.name}</>
            : <>{associationData?.association?.name}</>
          }
        </h3>
      }
      <div className='shop-title-inactive flex flex-col gap-2'>
        <h1>Webshopen är stängd</h1>
        <p>Försäljningen avslutades {endDate.toLocaleDateString('sv-SE')}.<br /> Tack för ditt stöd!</p>
      </div>
    </>
  }

  // If we're in the sales period and there are no booklets, show the no booklets message
  if (bookletsLength === 0) {
    return <>
      <h1>Inga häften tillgängliga</h1>
      <p>Inga häften tillgängliga för denna förening.</p>
    </>
  }

  return (
    <>
      <h1>
        {associationData && teamData && teamMemberData
          ? <>{teamMemberData?.teamMember?.firstname} {teamMemberData?.teamMember?.lastname}</>
          : teamData ? teamData?.team?.name
            : associationData?.association?.name
        }
      </h1>
      {teamData &&
        <h3>
          {teamMemberData
            ? <>{teamData?.team?.name}, {associationData?.association?.name}</>
            : <>{associationData?.association?.name}</>
          }
        </h3>
      }
    </>
  );
}

export default ShopTitle; 
